import type { Feature, Point } from 'geojson';
import { NextBikeSource } from './NextBikeSource';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions: AjaxSourceOptions = {
    id: 'styr-och-ställ-source',
    displayName: 'Lånecyklar',
};

interface NextBikeResponse {
    countries: NextBikeCountry[];
}

interface NextBikeCountry {
    cities: NextBikeCity[];
}

interface NextBikeCity {
    places: NextBikePlace[];
}

interface NextBikePlace {
    uid: number;
    lat: number;
    lng: number;
    bike: boolean;
    name: string;
    bikes: number;
    bikes_available_to_rent: number;
    bike_numbers: number[];
}

export interface StyrOchStällItem {
    stationId: string | number;
    long: number;
    lat: number;
    name: string;
    distance?: number;
    isOpen?: boolean;
    bikeStands?: number;
    availableBikes?: number;
    availableBikeStands?: number;
    bikeIds?: number[];
    lastUpdate?: string;
}

export interface StyrOchStällItemProperties extends StyrOchStällItem {
    lastUpdateDate?: Date;
}

export class StyrOchStällSource extends NextBikeSource {
    constructor(options?: Partial<AjaxSourceOptions>) {
        super('658', { ...defaultOptions, ...options });
    }

    parseData = (response: NextBikeResponse): Feature<Point, StyrOchStällItemProperties>[] => {
        return response.countries[0]?.cities[0]?.places.map((place) => ({
            id: place.uid,
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [place.lng, place.lat],
            },
            properties: {
                stationId: place.uid,
                lat: place.lat,
                long: place.lng,
                name: place.name,
                distance: 0,
                isOpen: true,
                bikeStands: place.bikes,
                availableBikes: place.bikes_available_to_rent ?? 0,
                availableBikeStands: undefined,
                lastUpdateDate: new Date(),
                bikeIds: place.bike_numbers,
                lastUpdate: '',
                type: place.bike ? 'bike' : 'station',
            },
        }));
    };
}
